import Tile from "../Tile/Tile"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { ViewableMarketingSummarySettingsModal } from "./ViewableMarketingSummarySettingsModal"
import {
  PaperAirplaneIcon,
  CursorArrowRaysIcon,
  EyeIcon,
  PencilSquareIcon,
  MinusCircleIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline"

export default function ViewableMarketingSummaryTile({
  canEdit = true,
  overview,
  tileFetchParams,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    overview,
    tileSettingsComponent: ViewableMarketingSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  if (!tile.data) return null

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileFetchParams.id}
      title={tile.name}
      canEdit={canEdit}
    >
      <div className="w-full divide-y divide-gray-200">
        <div
          className="grid py-2.5 text-left"
          style={{ gridTemplateColumns: "fit-content(80%) 1fr" }}
        >
          <div className="flex items-center gap-2 pr-1.5 text-sm text-gray-500">
            <PaperAirplaneIcon className="h-5 w-5 text-gray-400" />
            <p className="truncate">Emails Sent</p>
          </div>
          <div className="flex items-center justify-end text-sm">
            {tile.data.emails_sent}
          </div>
        </div>

        <div
          className="grid py-2.5 text-left"
          style={{ gridTemplateColumns: "fit-content(80%) 1fr" }}
        >
          <div className="flex items-center gap-2 pr-1.5 text-sm text-gray-500">
            <CursorArrowRaysIcon className="h-5 w-5 text-gray-400" />
            <p className="truncate">Click-Throughs</p>
          </div>
          <div className="flex items-center justify-end gap-1 text-sm">
            <span>{tile.data.email_click_throughs}</span>
            <span className="text-gray-400">
              ({tile.data.email_click_through_percentage}%)
            </span>
          </div>
        </div>

        <div
          className="grid py-2.5 text-left"
          style={{ gridTemplateColumns: "fit-content(80%) 1fr" }}
        >
          <div className="flex items-center gap-2 pr-1.5 text-sm text-gray-500">
            <EyeIcon className="h-5 w-5 text-gray-400" />
            <p className="truncate">Flyer Visits</p>
          </div>
          <div className="flex items-center justify-end text-sm">
            {tile.data.flyer_visits}
          </div>
        </div>

        <div
          className="grid py-2.5 text-left"
          style={{ gridTemplateColumns: "fit-content(80%) 1fr" }}
        >
          <div className="flex items-center gap-2 pr-1.5 text-sm text-gray-500">
            <PencilSquareIcon className="h-5 w-5 text-gray-400" />
            <p className="truncate">CAs Signed</p>
          </div>
          <div className="flex items-center justify-end text-sm">
            {tile.data.signed_confidentiality_agreement_count}
          </div>
        </div>

        <div
          className="grid py-2.5 text-left"
          style={{ gridTemplateColumns: "fit-content(80%) 1fr" }}
        >
          <div className="flex items-center gap-2 pr-1.5 text-sm text-gray-500">
            <MinusCircleIcon className="h-5 w-5 text-gray-400" />
            <p className="truncate">Passes</p>
          </div>
          <div className="flex items-center justify-end text-sm">
            {tile.data.passed_counterparties}
          </div>
        </div>

        <div
          className="grid py-2.5 text-left"
          style={{ gridTemplateColumns: "fit-content(80%) 1fr" }}
        >
          <div className="flex items-center gap-2 pr-1.5 text-sm text-gray-500">
            <BanknotesIcon className="h-5 w-5 text-gray-400" />
            <p className="truncate">Offers</p>
          </div>
          <div className="flex items-center justify-end text-sm">
            {tile.data.counterparty_offers}
          </div>
        </div>
      </div>
    </Tile>
  )
}
